import { useEffect } from 'react';
import { processWidgetAction } from '../store/widget/widgetServices';

export const useWidgetListener = () => {
    useEffect(() => {
        const listenerCallback = (event: MessageEvent) => processWidgetAction(event);
        window.addEventListener('message', listenerCallback, false);
        return () => {
            window.removeEventListener('message', listenerCallback, false);
        };
    }, []);
};
